
import { computed, defineComponent } from "vue";
import { useI18n } from "vue-i18n";

import enUK from "@/locales/project/en-UK.json";

import MutateEntity from "@/components/CRUXEntity/MutateEntity.vue";

import { required } from "@vuelidate/validators";
import { DELETE_PROJECT_RESOURCE } from "@/graphql/project/mutations";
import { GET_PROJECT_RESOURCES } from "@/graphql/project/queries";
import { ProjectResource } from "@/helpers/typesDefinition";

type MessageSchema = typeof enUK;

export default defineComponent({
  setup: function (props, { emit }) {
    const { t } = useI18n<[MessageSchema], "en-UK">({
      useScope: "global",
      inheritLocale: true,
      messages: {
        "en-UK": enUK,
      },
    });

    const entityProps = {
      selectedResource: undefined,
    };

    const validationRules = computed(() => ({
      selectedResource: { required },
    }));

    const messages = {
      title: t("titles.resource.delete"),
      formButtonLabel: t("buttons.resource.delete"),
      error: t("errors.deleteResource"),
      success: t("success.deleteResource"),
    };

    const closeModal = () => emit("close");

    const refetchQueries = [
      {
        query: GET_PROJECT_RESOURCES,
        variables: {
          projectId: props.projectId,
        },
      },
    ];

    const formOptions = props.projectResources.map((value) => ({
      id: value.id,
      name: value.label ?? value.link,
      selectedResource: value.id,
    }));

    return {
      t,
      enUK,
      entityProps,
      validationRules,
      messages,
      closeModal,
      DELETE_PROJECT_RESOURCE,
      refetchQueries,
      formOptions,
    };
  },
  props: {
    projectId: {
      type: String,
      required: true,
    },
    projectResources: {
      type: Array<ProjectResource>,
      required: true,
    },
  },
  emits: ["close"],
  components: {
    MutateEntity,
  },
});
